import React from "react";
import { Button, Modal } from "react-bootstrap";

import styles from "../../AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow.module.css";

function NotificationWindow({ isError, messageText, headerText, setShow, show, onClose }) {
  const handleClose = () => {
    if (!isError) return;

    if (onClose) {
      onClose();
    } else {
      setShow(!show);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title
          className={styles["form-title"]}
          id="contained-modal-title-vcenter">
          {headerText}
        </Modal.Title>
      </Modal.Header>

      {!!messageText && (
        <Modal.Body className={styles["form-body"]}>
          <div className={styles["label"]}>{messageText}</div>
        </Modal.Body>
      )}

      <Modal.Footer className={styles["form-footer"]}>
        <div
          className={styles["close-btn"]}
          onClick={handleClose}>
          Закрыть
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default NotificationWindow;
